import styles from "./UploadGridItem.module.css";
import downloadFile from "../../services/DownloadFile";
import React from "react";
import DeleteModal from "../DeleteView/DeleteModal";
import {
    ImageDeleteCheckbox,
    isSelectedForDelete
} from "../ImageDeleteCheckbox/ImageDeleteCheckbox";
import { useSelector } from "react-redux";
import { ImageDeleteData } from "../../types/ImageDeleteData";
import MainFrameContextType from "../../types/MainFrameContextType";
import { MainFrameContext } from "../contexts/MainFrameContext";
import { useLocation } from "react-router";

const DisplayImage = (props: any) => {
    const photosComplete: boolean = useSelector(
        (state: any) =>
            state.portal.activeInspection.SurveyorCompletionStatus
                .PhotosComplete
    );
    const inDeleteMode: boolean = useSelector(
        (state: any) => state.portal.activeInspection.ImageDeleteMode
    );
    const imagesDeleteList: ImageDeleteData[] = useSelector(
        (state: any) => state.portal.activeInspection.ImageDeleteList
    );
    let { allowDelete } = React.useContext(
        MainFrameContext
    ) as MainFrameContextType;
    const location = useLocation();

    if (
        location.pathname.includes("/photos") &&
        !location.pathname.endsWith("/photos")
    ) {
        allowDelete = true; // Sets allowDelete to true if a refresh occurs on a sub photo menu
    }

    const deleteSvg: string = photosComplete
        ? "/images/Roll-Over-Delete-Disable.svg"
        : "/images/Roll-Over-Delete.svg";
    const cursorStyle = photosComplete ? "default" : "pointer";

    const [showDeleteModal, setShowDeleteModal] = React.useState(false);

    function onDownload(onClickEvent: any) {
        downloadFile(props.image.url, props.image.name);
        onClickEvent.stopPropagation();
    }

    function onDelete(onClickEvent: any) {
        if (!photosComplete) {
            setShowDeleteModal(true);
        }
        onClickEvent.stopPropagation();
    }

    return (
        <>
            <DeleteModal
                elementId={props.element.Id}
                asset={props.image}
                active={showDeleteModal}
                closeModal={() => {
                    setShowDeleteModal(false);
                }}
            />
            <div
                onClick={props.clickHandler}
                data-content={props.remaining}
                className={props.selectedStyle}
                style={{
                    backgroundImage: `url(${props.image.url}) , url(/images/image-not-found.png)`
                }}
            >
                <div
                    className={
                        isSelectedForDelete(props.image.id, imagesDeleteList) &&
                        allowDelete
                            ? styles.transparentLayerVisible
                            : styles.transparentLayerHidden
                    }
                >
                    {!allowDelete ? (
                        <div />
                    ) : (
                        <ImageDeleteCheckbox
                            elementId={props.element.Id}
                            assetId={props.image.id}
                        />
                    )}
                    {inDeleteMode && allowDelete ? (
                        <div />
                    ) : (
                        <div>
                            <div
                                onClick={onDelete}
                                className={styles.deleteIcon}
                                style={{ cursor: cursorStyle }}
                            >
                                <a target="_blank" onClick={onDelete}>
                                    <img alt="Delete" src={deleteSvg} />
                                </a>
                            </div>
                            <div className={styles.viewIcon}>
                                <a target="_blank">
                                    <img
                                        alt="View"
                                        src="/images/Roll-Over-View.svg"
                                    />
                                </a>
                            </div>
                            <div className={styles.downloadIcon}>
                                <a target="_blank" onClick={onDownload}>
                                    <img
                                        alt="Download"
                                        src="/images/Roll-Over-Download.svg"
                                    />
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default DisplayImage;
